module.exports = __webpack_public_path__ + "img/sld_scb_12_t1_green.e47e9c5a.svg";